<!-- 大转盘 -->
<template>
  <div class='lottery-container'>
    <top></top>
    <div class="wrapper">
      <div class="left">
        <img src="../../assets/img/lottery/icon_1_l.png">
        <span>{{userInfo.app.credit_alias}}抽奖拼手气</span>
      </div>
      <div class="right" @click="popupRule">
        <img src="../../assets/img/lottery/icon_2.png">
        <span>抽奖规则</span>
      </div>
    </div>
    <div class="lottery-wrapper">
      <img :src="lightImg">
      <square class="lottery" :beforeLottery="beforeLottery" :afterLottery="afterLottery" :lotteryBtn="lotteryBtn" :prizesList="prizesList" :prize="prize"></square>
    </div>
    <div class="log" @click="toLog">
      <div class="left">
        <img src="../../assets/img/lottery/icon_1_l.png">
        <span>历史中奖纪录</span>
      </div>
      <div class="right">{{length}}条 ></div>
    </div>
    <bottom></bottom>
    <van-popup v-model="showAward" class="award-content">
      <h1>恭喜您获得</h1>
      <p>{{prizeData.product.name}}</p>
      <img :src="prizeData.product.image">
      <div @click="colse">确认</div>
      <span>可在中奖记录中查看、领取中奖产品</span>
    </van-popup>
    <van-popup v-model="showRule" class="rule-content">
      <h1>抽奖规则</h1>
      <p>{{rule.intro}}</p>
      <span @click="colseRule">确认</span>
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Vue from 'vue'
import top from '@/components/top'
import bottom from '@/components/bottom'
import Square from '@/components/lottery'
import { Popup } from 'vant'
import { Toast } from 'vant'

Vue.use(Popup)

export default {
  name: 'Lottery',
  components: { Square, top, bottom },
  data() {
    return {
      prize: 0,
      prizeData: { product: {}},
      rule: {},
      prizesList: [],
      lotteryBtn: {
        img: require('../../assets/img/lottery/btn_go.png')
      },
      lightImg: require('../../assets/img/lottery/img_light_1.png'),
      showAward: false,
      showRule: false,
      length: 0,
      interval: null
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },

  created() {
    this.getLottery()
    this.getLength()
  },

  methods: {
    getLottery() {
      var that = this
      this.axios.get('/credit/lottery/config/').then(function(res) {
        console.log(res.data)
        if (res.data.count) {
          that.rule = res.data.results[0]
          // 将奖品按照sort从小到大排序
          that.rule.products.sort(function(a, b) {
            return a.sort - b.sort
          })
          for (const item of that.rule.products) {
            that.prizesList.push(item.image)
          }
        } else {
          Toast('抽奖活动未配置')
        }
      }).catch(function(error) {
        console.log(error.response)
        Toast(error.response.data.detail)
      })
    },

    getLength() {
      var that = this
      this.axios.get('/credit/lottery/log/').then(function(res) {
        that.length = res.data.count
      }).catch(function(error) {
        console.log(error)
      })
    },

    /*
      * 点击抽奖
    **/
    beforeLottery(resolve, reject) {
      var that = this
      if (this.userInfo.credit < 12) {
        return Toast(this.userInfo.app.credit_alias + '不足')
      }
      this.axios.post('/credit/lottery/', {}, { headers: { 'X-LOTTERY-ID': this.rule.id }}).then(function(res) {
        console.log(res.data)
        that.prize = res.data.product.sort - 1
        that.prizeData = res.data
        var times = 1
        that.interval = setInterval(() => { // 灯闪效果
          times++
          if (times % 2) {
            that.lightImg = require('../../assets/img/lottery/img_light_1.png')
          } else {
            that.lightImg = require('../../assets/img/lottery/img_light_2.png')
          }
        }, 200)
        resolve()
      }).catch(function(error) {
        console.log(error.response)
        Toast(error.response.data.detail)
      })
    },

    /*
      * 转盘停止
    **/
    afterLottery() {
      clearInterval(this.interval)
      this.showAward = true
      this.$store.dispatch('updateCredit', this.userInfo.credit - this.rule.burn)
      if (this.prizeData.product.type) {
        this.length += 1
      }
      if (this.prizeData.product.type !== 2) {
        this.$store.dispatch('updateCredit', this.userInfo.credit + this.prizeData.product.price)
      }
    },

    popupRule() {
      this.showRule = true
    },

    colseRule() {
      this.showRule = false
    },

    colse() {
      this.showAward = false
      console.log(this.prizeData)
      if (this.prizeData.product.type === 3) {
        // this.$router.go(-1)
        window.location.href = this.prizeData.product.url
      }
    },

    toLog() {
      this.$router.push({ path: '/activity/log' })
    }
  }
}
</script>

<style lang="scss" scoped>
.lottery-container{
  .wrapper{
    margin-top: 65px;
    padding: 5px 15px 10px;
    display: flex;
    justify-content: space-between;
    .left{
      display: flex;
      align-items: center;
      img{
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }
      span{
        color: #000000;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .right{
      display: flex;
      align-items: center;
      img{
        width: 12px;
        height: 12px;
        margin-right: 8px;
      }
      span{
        color: #747474;
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  .lottery-wrapper{
    width: 100%;
    height: 350px;
    background: url('../../assets/img/lottery/img_background.png');
    background-size: 100% 100%;
    position: relative;
    overflow: hidden;
    img{
      width: 355px;
      display: block;
      margin: 10px auto 0;
      height: 330px;
    }
    .lottery{
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .log{
    width: 250px;
    height: 50px;
    padding: 0 15px;
    margin: 10px auto 0;
    background-color: #ffffff;
    border-radius: 25px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      display: flex;
      align-items: center;
      img{
        width: 25px;
        height: 25px;
        margin-right: 10px;
      }
      span{
        color: #4a4a4a;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .right{
      color: #747474;
      font-size: 12px;
      font-weight: 400;
    }
  }
  .award-content{
    width: 300px;
    height: 310px;
    padding: 10px 0;
    box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    h1{
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
      margin: 0;
    }
    p{
      color: #747474;
      font-size: 14px;
      font-weight: 400;
    }
    img{
      width: 150px;
      height: 120px;
    }
    div{
      width: 150px;
      height: 40px;
      border-radius: 100px;
      background-color: #ff6d63;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      line-height: 40px;
      text-align: center;
    }
    span{
      color: #aaaaaa;
      font-size: 14px;
      font-weight: 400;
    }
  }
  .rule-content{
    width: 250px;
    padding: 25px;
    box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    background-color: #ffffff;
    h1{
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 600;
      margin: 0;
      text-align: center;
    }
    p{
      margin: 20px 0;
      color: #4a4a4a;
      font-size: 16px;
      font-weight: 400;
      line-height: 25px;
    }
    span{
      color: #4a90e2;
      font-size: 16px;
      font-weight: 400;
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/lottery.vue